import { useQuery } from "@tanstack/react-query";
import { QueryOptionsTyped } from "../types";
import { buildDefaultQueryOptions } from "../common";
import { ApiResponse } from "@typeDefinitions";
import { fetchClinicDietitians } from "@client/settings";
import { DietitianClinicListResource } from "@client/resources/ClinicDietitianResource";
import { clinicKeys } from "@hooks/queries/clinic/clinicKeys";

export const useFetchClinicDietitiansQuery = (
  options?: QueryOptionsTyped<ApiResponse<DietitianClinicListResource[]>>,
) => {
  const { data, ...rest } = useQuery(
    clinicKeys.dietitians(),
    fetchClinicDietitians,
    buildDefaultQueryOptions(options),
  );

  return {
    data: data?.data,
    ...rest,
  };
};
